export default __webpack_public_path__ + "static/favicon-192-5528d9f7cd54999dcb58db0b4b7426c3.png";